import { atom } from 'jotai'

// 编辑题目是否开始校验字段，在点击「创建」/「修改」题目时，开始校验
export const isValidQuestionFieldAtom = atom<boolean>(false)
